import { TextInputTheme } from '@sternum/ui';

export const sizes: TextInputTheme['default']['sizes'] = {
  normal: {
    paddingHorizontal: '16px',
    paddingVertical: '0px',
    fontSize: '12px',
    lineHeight: '20px',
  },
  small: {
    paddingHorizontal: '16px',
    paddingVertical: '0px',
    fontSize: '12px',
    lineHeight: '20px',
  },
};

export const icon: TextInputTheme['default']['icon'] = {
  normal: {
    width: '18px',
    height: '18px',
    left: '12px',
    right: '12px',
  },
  small: {
    width: '18px',
    height: '18px',
    left: '12px',
    right: '12px',
  },
};
